module.exports = __webpack_public_path__ + "static/media/what.5d51b613.png";